import React, { ChangeEvent } from 'react';

import groupedUnits from 'components/basic/dropdowns/dataset-unit-selector/units';
import {
	HighlightRange,
	IProductTemplateAttribute,
} from 'components/dashboard/product-template-table/utils/interfaces';
import { Chips } from 'primereact/chips';
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';
import {
	InputNumber,
	InputNumberValueChangeParams
} from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { ColumnAggregationType } from 'utils/enums';
import OutputValidation from './components/OutputValidation';

type LongAndDoubleTypesProps = {
	attribute: IProductTemplateAttribute;
	onAttrChangeInLongAndDouble: React.Dispatch<
		React.SetStateAction<IProductTemplateAttribute>
	>;
};

const LongAndDoubleTypes: React.FC<LongAndDoubleTypesProps> = ({
	attribute,
	onAttrChangeInLongAndDouble,
}) => {
	const bgHighlightList = [...(attribute.bgHighlightRanges ?? [])];

	const updateAttributeChange = (newBgList: HighlightRange[]) => {
		onAttrChangeInLongAndDouble(prev => ({
			...prev,
			bgHighlightRanges: newBgList,
		}));
	};

	const onFieldChange = (
		e:
			| DropdownChangeParams
			| InputNumberValueChangeParams
			| ChangeEvent<HTMLInputElement>,
	) =>
		onAttrChangeInLongAndDouble(prev => ({
			...prev,
			[e.target.name]: e.target.value ?? null,
		}));

	return (
		<>
			<div className='p-field p-col-2'>
				<label>Unit</label>
				<Dropdown
					value={attribute.unit}
					onChange={onFieldChange}
					name='unit'
					className='p-inputtext-sm'
					options={groupedUnits}
					optionLabel='label'
					optionGroupLabel='label'
					optionGroupChildren='items'
					editable
				/>
			</div>
			<div className=' p-field p-col-2'>
				<label>Decimal places</label>
				<InputNumber
					placeholder='Number of decimal places to show'
					value={attribute.decimalPlaces}
					onValueChange={onFieldChange}
					name='decimalPlaces'
					className='p-inputtext-sm'
				/>
			</div>

			<div className='p-field p-col-2'>
				<label>Aggregation type</label>
				<Dropdown
					options={Object.values(ColumnAggregationType)}
					value={attribute.aggregationType ?? ColumnAggregationType.SUM}
					onChange={onFieldChange}
					name='aggregationType'
					className='p-inputtext-sm'
				/>
			</div>
			<div className='p-field p-col-6'>
				<label>Evaluation expression</label>
				<InputText
					placeholder='e.g. $some_attr1 + $some_attr3 * $some_attr_2'
					value={attribute.evaluationExpression ?? ''}
					onChange={onFieldChange}
					name='evaluationExpression'
					className='p-inputtext-sm'
				/>
			</div>
			<div className='p-field p-col-9'>
				<label>Selection values</label>
				<Chips
					value={attribute.selectionValues ?? []}
					onChange={onFieldChange}
					name='selectionValues'
					separator=','
					keyfilter='num'
				/>
			</div>
			<div className='p-field p-col-3'>
				<label>Default value</label>
				<Dropdown
					value={attribute.defaultValue}
					options={attribute.selectionValues ?? []}
					onChange={onFieldChange}
					name='defaultValue'
					className='p-inputtext-sm'
					editable
				/>
			</div>
			<OutputValidation bgHighlights={bgHighlightList} onAttributeChange={updateAttributeChange} />
		</>
	);
};

export default LongAndDoubleTypes;
